const ApiURL = "https://crmgateway-stage.codesour.dev/v1";
const ApiURLLead = "https://crmgateway.codesour.dev/v1";
export const crmService = {
  getCompany,
  getLead,
  getCompanyNotPec,
  generateUrl,
  update,
  updateSent,
  getCompanyById,
  getCompaniesByIds,
  getPossibleLead,
  detetePossibleLead,
  saveLead,
};

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      switch (response.status) {
        case 401:
          console.error("incorect email or password");
          return Promise.reject({ ...data, statusCode: 401 });
        case 409:
          return Promise.reject({ ...data, statusCode: 409 });
        case 404:
          return Promise.reject(data);
        default:
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function getCompany() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + "/company/all", requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getLead() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURLLead + "/lead/all", requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getCompanyNotPec() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + "/company/allNotPec", requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function generateUrl(payload) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(ApiURL + "/company/generateUrl", requestOptions)
    .then((res) => {
      return res.text();
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function update(payload) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(ApiURL + "/company/update", requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function updateSent(id) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/company/updateSent?id=${id}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getCompanyById(id) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/company/findById/${id}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res !== null) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getCompaniesByIds(ids) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(ids),
  };
  return fetch(ApiURL + `/company/findByIds`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res !== null) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}


function getPossibleLead() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/possibleLead/all`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res !== null) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function detetePossibleLead(id) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/possibleLead/delete/${id}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res !== null) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function saveLead(lead) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(lead),
  };
  return fetch(ApiURL + `/crm/createLead`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res !== null) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}



